import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { LayoutSplashScreen } from "../../../_metronic";
import { gql } from "apollo-boost";
import { useMutation } from "@apollo/react-hooks";
import keys from "../../../config/keys";
import ApolloClient from "apollo-boost";
import { getCsrfToken } from '@utils/common';
import * as auth from "../../store/ducks/auth.duck";

const LOGOUT_USER = gql`
  mutation {
    LogoutUser {
      _id
    }
  }
`;

function Logout(props) {
  const history = useHistory();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const client = new ApolloClient({
    uri: keys.graphqluri,
    credentials: "include",
  request: (operation) => {
    operation.setContext({
      headers: {
        "X-CSRF-Token": getCsrfToken(),
      },
    });
  },
  });

  const [logoutUser] = useMutation(LOGOUT_USER, { client });

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const response = await fetch("/api/user/me", {
          method: "GET",
          credentials: 'include',
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": getCsrfToken(),
          }
        });

        if (!response.ok) throw new Error("Unauthorized");

        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    checkAuthStatus();
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      logoutUser()
        .then(() => {
          fetch("/api/user/logout", {
            method: "POST",
            credentials: 'include',
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": getCsrfToken(),
            }
          })
            .then(() => {
              setIsAuthenticated(false);

              props.logout();

              window.location.replace("/auth/login");
            });
        })
        .catch((error) => {
          console.error("Logout error:", error);
          props.logout();
          window.location.replace("/auth/login");
        });
    }
  }, [isAuthenticated, logoutUser, props]);

  if (isAuthenticated === null) {
    return <LayoutSplashScreen />;
  }

  return null;
}

export default connect(null, { logout: auth.actions.logout })(Logout);
